# Branding

Branding allows SEEK hirers to promote their company brand on their job ads through a logo and optional cover image.
Not all [SEEK ad products] include branding;
you can query the [ad product’s features] to determine if branding is available.

The SEEK API provides two queries for retrieving brands:

- [`advertisementBrandings`] returns a paginated list of brands for a given hirer.
- [`advertisementBranding`] returns a brand for a given brand object identifier.

If you haven’t yet built this feature into your software, refer to the [Branding] documentation.

[ad product’s features]: /schema/named-type/AdvertisementProductFeatures
[seek ad products]: /use-cases/job-posting/ad-selection
[`advertisementBrandings`]: /use-cases/job-posting/branding#advertisementbrandings
[`advertisementBranding`]: /use-cases/job-posting/branding#advertisementbranding
[Branding]: /use-cases/job-posting/branding
